import { AppHeader } from '../components/layout/AppHeader';
import { PageShell } from '../components/layout/PageShell';
import { Button } from '../components/ui/Button';
import { Panel } from '../components/ui/Panel';
import { navigate } from '../hooks/useHashRoute';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="app-shell">
      <AppHeader />
      <PageShell>
        <Panel title="Page not found" description="The requested Pilum Trade Lab screen does not exist.">
          <div className="attribution-list">
            <Button variant="primary" onClick={() => navigate('/')}>Open opportunity tables</Button>
          </div>
        </Panel>
      </PageShell>
    </div>
  );
}
